<template>
    <!-- 兑换活动管理-详情 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'exchangeGiftDetail')">
            <div slot="header" class="ml16">
                <div class="font-biggest font-bold mb8 text-color-85">{{dataDetail.couponName}}</div>
                <div class="mb8">
                    <span class="mr80">创建用户：{{dataDetail.createUser}}</span>
                    <span>创建时间：{{dataDetail.createTime}}</span>
                </div>
                <a-tabs :defaultActiveKey="activeKey" @change="callback">
                    <a-tab-pane :key="1" tab="概览"></a-tab-pane>
                    <a-tab-pane :key="2" tab="兑换管理">
                        <a-form :form="form" layout="inline" class="store-one-form">
                            <a-form-item label="序列号SN">
                                <a-input placeholder="请输入" v-decorator="['sn']"></a-input>
                            </a-form-item>
                            <a-form-item label="兑换简码">
                                <a-input placeholder="请输入" v-decorator="['shortCode']"></a-input>
                            </a-form-item>
                            <a-form-item label="兑换码状态">
                                <a-select allowClear placeholder="请选择" v-decorator="['isUse']">
                                    <a-select-option value="1">已兑换</a-select-option>
                                    <a-select-option value="0">未兑换</a-select-option>
                                    <a-select-option value="-1">已禁用</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="兑换方式">
                                <a-select allowClear placeholder="请选择" v-decorator="['useType']">
                                    <a-select-option value="0">通用码</a-select-option>
                                    <a-select-option value="1">一物一码</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="兑换手机号">
                                <a-input placeholder="请输入" v-decorator="['useUser']"></a-input>
                            </a-form-item>
                            <a-form-item label="兑换日期">
                                <a-range-picker
                                    style="width:282px"
                                    format="YYYY－MM－DD"
                                    v-decorator="['validity']"
                                />
                            </a-form-item>
                            <a-form-item label="团购订单号">
                                <a-input placeholder="请输入" v-decorator="['groupId']"></a-input>
                            </a-form-item>
                            <a-form-item label="团购客户名">
                                <a-input placeholder="请输入" v-decorator="['groupName']"></a-input>
                            </a-form-item>
                            <a-form-item class="wrap-header-button">
                                <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                                <a-button @click="handleReset">重置</a-button>
                            </a-form-item>
                        </a-form>
                    </a-tab-pane>
                    <a-tab-pane :key="3" tab="资源下载"></a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="activeKey == 1">
                <exchange-account title="兑换统计" :dataDetail="dataDetail"/>
                <exchange-outline title="兑换概要" :dataDetail="dataDetail"/>
                <exchange-goods class="mt24" title="商品信息" :goodsDetail="dataDetail" :goodsId="dataDetail.goodId" :goodsType="dataDetail.goodCategory"/>
            </div>
            <div v-if="activeKey == 2">
                <a-card>
                    <div slot="extra">
                        <a-button :loading="btnLoading" @click="disableOrOpenBatch(-1)">批量禁用</a-button>
                        <a-button :loading="btnLoading" @click="disableOrOpenBatch(0)">批量解禁</a-button>
                        <a-button :loading="btnLoading" @click="exprotExcel()">导出</a-button>
                        <a-button :loading="btnLoading" @click="exprotExcelAll()">全部导出</a-button>
                    </div>
                    <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    :rowSelection="{type: 'checkbox', onChange: tableSelectChange, selectedRowKeys: tableSelectedRowKeys}"
                    @change="changePage"
                    >
                        <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                        <span slot="status" slot-scope="status,row">{{row.status == -1 ? '已禁用' : (row.isUse ? '已兑换' : '未兑换')}}</span>
                        <span slot="useType" slot-scope="useType">{{['通用码','一物一码'][useType] || '-'}}</span>
                        <span slot="empty" slot-scope="empty">{{empty || '-'}}</span>
                        <span slot="validityStart" slot-scope="a,row">{{row.validityStart ? (row.validityStart + '~' + row.validityEnd) : '不限期'}}</span>
                        <span slot="action" slot-scope="a,row">
                            <a class="text-primary" @click="disableOrOpen(row.status == -1 ? 0 : -1,row.id)">{{row.isUse == 1 ? '' : (row.status ? '解禁' : '禁用')}}</a>
                        </span>
                    </a-table>
                </a-card>
            </div>
            <div v-if="activeKey == 3">
                <a-card class="pt24 pl24 pb24 pr24">
                    <div class="mb24">资源下载 
                        <a-tooltip>
                            <div slot="title">
                                兑换礼券发给客户的方式，可多选：<br>
                                •实体券：通过实体票券介质发给客户；<br>
                                •下载序列号SN二维码：打包下载序列号二维码图片，可作为商品标识；<br>
                                •下载兑换二维码：打包下载兑换二维码，可扫码兑换；<br>
                                •下载CSV文件：下载序列号-兑换码表格，可用来开发制作印刷等；<br>
                                •在线链接：生成自定义礼券/团购销售专属兑换链接； <br>
                                •api接口：提供对应接口信息，供客户通过接口调用兑换码。"<br>
                            </div>
                            <a-icon type="question-circle-o" />
                        </a-tooltip>
                    </div>
                    <a-card-grid @click="openModal(2)" class="mr24 text-center" style="width:16%;border-radius: 10px;cursor:pointer">
                        <div class="font-bigger">下载CSV文件</div>
                        <span class="font-smaller">序列号-兑换码表格</span>
                    </a-card-grid>
                    <a-card-grid class="mr24 text-center" style="width:16%;border-radius: 10px;background-color:#f8f8f8">
                        <div class="font-bigger">下载序列号SN二维码</div>
                        <span class="font-smaller">敬请期待</span>
                    </a-card-grid>
                    <!-- <a-card-grid @click="openModal(0)" class="mr24 text-center" style="width:20%;border-radius: 10px;cursor:pointer">
                        <div class="font-bigger">下载序列号SN二维码</div>
                        <span class="font-smaller">扫码识别兑换礼券</span>
                    </a-card-grid> -->
                    <a-card-grid @click="openModal(1)" class="mr24 text-center" style="width:18%;border-radius: 10px;cursor:pointer">
                        <div class="font-bigger">下载兑换二维码</div>
                        <span class="font-smaller">扫码识兑换领取凭证</span>
                    </a-card-grid>
                    <!-- <a-card-grid class="mr24 text-center" style="width:16%;border-radius: 10px;background-color:#f8f8f8">
                        <div class="font-bigger">下载兑换二维码</div>
                        <span class="font-smaller">敬请期待</span>
                    </a-card-grid> -->
                    <a-card-grid class="mr24 text-center" style="width:16%;border-radius: 10px;background-color:#f8f8f8" :hoverable="false">
                        <div class="font-bigger">在线链接</div>
                        <span class="font-smaller">敬请期待</span>
                    </a-card-grid>
                    <a-card-grid class="text-center" style="width:16%;border-radius: 10px;background-color:#f8f8f8" :hoverable="false">
                        <div class="font-bigger">api接口</div>
                        <span class="font-smaller">敬请期待</span>
                    </a-card-grid>
                </a-card>
                <a-card class="mt24">
                    <a-button type="primary" slot="extra" @click="exchangeGiftDownloadList">刷新</a-button>
                    <a-table
                    bordered
                    :dataSource="dataDownloadList"
                    :columns="columnsDown"
                    :pagination="pagination"
                    :rowKey="record => record.id"
                    @change="changePage"
                    >
                        <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                        <span slot="status" slot-scope="status">{{status == -1 ? '失败' : status == 0 ? '生成中' : '成功'}}</span>
                        <span slot="empty" slot-scope="empty">{{empty || '-'}}</span>
                        <span slot="action" slot-scope="a,row">
                            <a v-if="getBtnByAuth('download') && row.status == 1 && row.isDownload == 0" class="text-primary" @click="exchangeGiftDownload(row.id, row.content)">下载</a>
                        </span>
                    </a-table>
                </a-card>
                <a-modal v-model="visible" :confirmLoading="loading" centered okText="确认下载" @ok="exchangeGiftDownloadMake" @cancel="cancel">
                    <div slot="title">
                        {{maintitle}}
                        <span class="text-color-45 font-smaller">{{subtitle}}</span>
                    </div>
                    <a-form :form="formModal">
                        <a-form-item :label="this.type == 0 ? '序列号SN范围' : '兑换码范围'" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-select placeholder="请选择" v-decorator="['eventId',{rules: [{required: true, message: '请选择兑换码范围'}],initialValue:'-1'}]">
                                <a-select-option v-for="(item, index) in downLoadScope" :key="index" :value="item.eventId">{{item.showName}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item v-show="type != 0" label="兑换码形式" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                            <a-radio-group :disabled="type == 1" v-decorator="['codeType',{initialValue: 1}]" >
                                <a-radio :value="1">一物一码</a-radio>
                                <a-radio :value="0">通用码</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-form>
                    <div v-if="this.type != 0" class="text-fail mt24">注意：兑换码为虚拟有价资产，下载使用注意文件安全保密。</div>
                </a-modal>
            </div>
            <a-modal :title="operateTitle" centered v-model="visable" @cancel="visable = false; remark = undefined">
                <a-alert :message="warningText" banner />
                <a-row class="mt16">
                    <a-col :span="3"><span class="text-fail">*</span> 备注：</a-col>
                    <a-col :span="21"><a-textarea v-model="remark" placeholder="请输入备注" /></a-col>
                </a-row>
                <template slot="footer">
                    <a-button @click="visable = false; remark = undefined">
                    取消
                    </a-button>
                    <a-button type="primary" :disabled="!remark" :loading="btnLoading" @click="handleOk">
                    确定
                    </a-button>
                </template>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import exchangeAccount from "@/components/modules/change-code/exchange-account.component";
    import exchangeGoods from "@/components/modules/change-code/exchange-goods.component";
    import exchangeOutline from "@/components/modules/change-code/exchange-outline.component";

    const columns = [
        {
            title: "序列号SN",
            dataIndex: "sn",
        },
        {
            title: "兑换简码",
            dataIndex: "shortCode",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "兑换码状态",
            dataIndex: "status",
            scopedSlots: { customRender: "status" }
        },
        {
            title: "兑换方式",
            dataIndex: "useType",
            scopedSlots: { customRender: "useType" }
        },
        {
            title: "兑换手机号",
            dataIndex: "useUser",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "兑换时间",
            dataIndex: "useTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "团购订单号",
            dataIndex: "groupId",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "团购客户名",
            dataIndex: "groupName",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columnsDown = [
        {
            title: "NO.",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "下载内容",
            dataIndex: "content"
        },
        {
            title: "状态",
            dataIndex: "status",
            scopedSlots: { customRender: "status" }
        },
        {
            title: "创建用户",
            dataIndex: "createUser",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "创建时间",
            dataIndex: "createTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "下载用户",
            dataIndex: "downloadUser",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "下载时间",
            dataIndex: "downloadTime",
            scopedSlots: { customRender: "empty" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    export default {
        name: "exchangeGiftDetail",
        components: {
            exchangeAccount,
            exchangeGoods,
            exchangeOutline,
        },
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                columnsDown,
                dataDownloadList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                form: this.$form.createForm(this),
                formModal: this.$form.createForm(this),
                activeKey: 1,
                visible: false,
                dataDetail: {},
                maintitle: undefined,
                subtitle: undefined,
                type: undefined,
                loading: false,
                tableSelectedRowKeys: [],
                operateTitle: '',
                warningText: '',
                remark: undefined,
                visable: false,
                btnLoading: false,
                tableSelectedRows: [],
                downLoadScope: []
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {},
        methods: {
            getDownLoadScope() {
                this.$api.changeCode.getDownLoadScope({
                    query: {
                        couponId: this.$route.query.id
                    }
                }).then( res => {
                    this.downLoadScope = res;
                })
            },
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                if(this.activeKey == 3) {
                    this.exchangeGiftDownloadList()
                }else if(this.activeKey == 2) {
                    this.getList()
                }
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                if(this.activeKey == 3) {
                    this.exchangeGiftDownloadList()
                }else if(this.activeKey == 2) {
                    this.getList()
                }
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startUseTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : ''
                    values.endUseTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : ''
                    delete values.validity

                    this.$api.changeCode
                    .cashCodeList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            id: this.$route.query.id
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    })
                });
            },
            getDetail() {
                this.$api.changeCode
                .exchangeGiftDetails({
                    query: {
                        id: this.$route.query.id
                    }
                })
                .then(res => {
                    this.dataDetail = res;
                });
            },
            callback(key) {
                this.activeKey = key;
                if(this.activeKey == 3) {
                    this.exchangeGiftDownloadList()
                }else if(this.activeKey == 2) {
                    this.getList()
                }
            },
            tableSelectChange(tableSelectedRowKeys,tableSelectedRows) {
                this.tableSelectedRowKeys = tableSelectedRowKeys;
                this.tableSelectedRows = tableSelectedRows;
            },
            disableOrOpen(status, id) {
                this.visable = true;
                this.operateTitle = status ? '禁用' : '解禁';
                this.warningText = status ? '禁用操作，未兑换的兑换码将无法兑换' : '解禁操作，禁用的兑换码将继续可兑换';
                this.operateParams = {
                    ids: id,
                    isOpen: status
                };
            },
            disableOrOpenBatch(status) {
                if(this.tableSelectedRowKeys.length == 0) {
                    this.$message.warning('选择不符合规范，请重新选择')
                    return
                }
                let flag1 = false;
                let flag2 = false;
                let flag3 = false;
                this.tableSelectedRows.forEach(item => {
                    if(status == -1) {
                        if(item.status == -1) {
                            flag1 = true
                        }
                    }else {
                        if(item.status == 0) {
                            flag2 = true
                        }
                    }
                    if(item.isUse == 1) {
                        flag3 = true
                    }
                })
                if(flag1) {
                    this.$message.warning('所选数据包含不可禁用，请重新选择')
                    return
                }
                if(flag2) {
                    this.$message.warning('所选数据包含不可解禁，请重新选择')
                    return
                }
                if(flag3) {
                    this.$message.warning('所选数据包含已兑换，请重新选择')
                    return
                }

                this.visable = true;
                this.operateTitle = status ? '禁用' : '解禁';
                this.warningText = status ? '禁用操作，未兑换的兑换码将无法兑换' : '解禁操作，禁用的兑换码将继续可兑换';
                this.operateParams = {
                    ids: this.tableSelectedRowKeys.join(','),
                    isOpen: status
                };
            },
            exprotExcel() {
                if(this.tableSelectedRowKeys.length == 0) {
                    this.$message.warning('选择不符合规范，请重新选择')
                    return
                }
                this.btnLoading = true;
                this.$api.changeCode
                .exportCashCodeListById({
                    body: {ids: this.tableSelectedRowKeys}
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    let name = '兑换明细_' + this.$route.query.id + '_' + this.$moment().format('YYYYMMDDHHmmss') + '.xls';

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.btnLoading = false

                }).catch(err => {
                    this.btnLoading = false;
                });
            },
            exprotExcelAll() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['validity'] ? values['validity'] : []
                    values.startUseTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : ''
                    values.endUseTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : ''
                    delete values.validity
                    
                    this.btnLoading = true;
                    this.$api.changeCode
                    .exportCashCodeList({
                        body: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: 999999,
                            id: this.$route.query.id
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = '兑换明细_' + this.$route.query.id + '_' + this.$moment().format('YYYYMMDDHHmmss') + '.xls';

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.btnLoading = false

                    }).catch(err => {
                        this.btnLoading = false;
                    });
                });
            },
            handleOk() {
                this.operateParams.remark = this.remark;
                this.btnLoading = true;
                this.$api.changeCode.disableOrOpenBatch({
                    query: this.operateParams
                }).then(res => {
                    this.btnLoading = false;
                    this.visable = false;
                    this.remark = undefined;
                    this.tableSelectedRows = [];
                    this.tableSelectedRowKeys = [];
                    this.$message.success('操作成功');
                    this.getList();
                }).catch(err => {
                    this.btnLoading = false;
                })
            },
            openModal(type) {
                this.visible = true;
                this.type = type
                if(type == 1) {
                    this.maintitle = '下载兑换二维码';
                    this.subtitle = '扫码兑换领取凭证';
                }else if(type == 0) {
                    this.maintitle = '下载序列号SN二维码';
                    this.subtitle = '扫码识别兑换凭证';
                }else if(type == 2) {
                    this.maintitle = '下载CSV文件';
                    this.subtitle = '序列号-兑换码表格';
                }
                this.getDownLoadScope();
            },
            exchangeGiftDownloadMake() {
                this.formModal.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    this.$api.changeCode.exchangeGiftDownloadMake({
                        query: {
                            ...values,
                            id: this.$route.query.id,
                            type: this.type
                        }
                    })
                    .then(data => {
                        setTimeout(()=> {
                            this.loading = false;
                            this.cancel();
                            this.$message.success('操作成功');
                            this.exchangeGiftDownloadList();
                        },500)
                    })
                    .catch(err => {
                        this.loading = false;
                    })
                });
            },
            exchangeGiftDownloadList() {
                this.$api.changeCode.exchangeGiftDownloadList({
                    query: {
                        id: this.$route.query.id,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                    }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataDownloadList = res.list;
                })
            },
            cancel() {
                this.visible = false;
                this.formModal.resetFields();
            },
            // 导出ZIP
            exchangeGiftDownload(id,content) {
                this.$api.changeCode
                .exchangeGiftDownload({
                    query: {   
                        id: id
                    }
                },
                {
                    responseType: "blob"
                })
                .then(res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/zip"
                    });

                    this.downloadUrl = window.URL.createObjectURL(blob);

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(content);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.exchangeGiftDownloadList()
                });
            },
        },
        beforeCreate() {},
        created() {},
        mounted() {
            this.getDetail();
            this.getList();
            this.exchangeGiftDownloadList();
        }
    };
</script>
<style lang="scss">
</style>